import React, { useState } from 'react';
import { Navbar, Nav, NavDropdown, Offcanvas, Container } from 'react-bootstrap';
import { Outlet, Link } from 'react-router-dom';
import logo from '../img/Logo.png';
import '../App.css';

function Header() {
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true);

  const handleLinkClick = () => {
    // Cierra el menú cuando se hace clic en un enlace
    handleClose();
  };

  return (
    <>
      <Navbar key="md" expand="md" className="navbar-dark navBg fixed-top" variant="dark">
        <Container fluid>
          <Navbar.Brand as={Link} to="/" onClick={handleLinkClick}>
            <img
              src={logo}
              alt="Logo"
              className="d-inline-block align-top img-fluid"
              style={{ maxHeight: '80px', width: 'auto' }}
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="offcanvasNavbar" onClick={handleShow} />
          <Navbar.Offcanvas
            show={showOffcanvas}
            onHide={handleClose}
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
            placement="end"
            className="bg-white text-dark"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id="offcanvasNavbarLabel">Menú</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="ms-auto flex-grow-1 pe-3">
                <Nav.Link as={Link} to="/" className="nav-link-mobile" onClick={handleLinkClick}>INICIO</Nav.Link>

                <NavDropdown title="NOSOTROS" id="nosotros-dropdown">
                  <NavDropdown.Item as={Link} to="/EnfoqueEstrategico" onClick={handleLinkClick}>Enfoque Estratégico</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/Queofrecemos" onClick={handleLinkClick}>Qué Ofrecemos</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/SectoresQueAtendemos" onClick={handleLinkClick}>Sectores que Atendemos</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/Certificaciones" onClick={handleLinkClick}>Certificaciones</NavDropdown.Item>
                </NavDropdown>

                <NavDropdown title="PRODUCTOS" id="productos-dropdown">
                  <NavDropdown.Item as={Link} to="/Bombas" onClick={handleLinkClick}>Bombas</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/EquiposDePresion" onClick={handleLinkClick}>Equipos de Presión</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/SistemaContraIncendiosNormalizados" onClick={handleLinkClick}>Sistemas Normalizados</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/SistemaContraIncendiosNoNormalizados" onClick={handleLinkClick}>Sistemas No Normalizados</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/OtrosEquipos" onClick={handleLinkClick}>Otros Equipos</NavDropdown.Item>
                </NavDropdown>

                <Nav.Link as={Link} to="/Contactanos" className="nav-link-mobile" onClick={handleLinkClick}>CONTÁCTANOS</Nav.Link>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>

      <div className="page-content">
        <Outlet />
      </div>
    </>
  );
}

export default Header;
